<template>
  <div class="operate">
    <div class="live">
      <el-row>
        <div class="seach-list r iblock">
          <el-select class="input-v" v-model="search.state" @change="getStatus">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="输入查询的内容"
            v-model="search.keywords"
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list">
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 40px 0;"
      >
        <el-table-column label="头像">
          <template slot-scope="scope">
            <img class="user_header" :src="scope.row.user_pfrofile_photo" alt />
          </template>
        </el-table-column>
        <el-table-column prop="user_nick_name" label="昵称"></el-table-column>
        <el-table-column prop="user_role" label="身份"></el-table-column>
        <el-table-column prop="comment_content" label="内容" min-width="100px"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.state==(-1)">隐藏</span>
            <span v-show="scope.row.state==(-2)">黑名单</span>
            <span v-show="scope.row.state==1">正常</span>
            <span v-show="scope.row.state==2">精选</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="发表时间"></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="mini" @click="isShow()">显示</el-button> -->
            <!-- <el-button type="text" size="mini" @click="isHide()">隐藏</el-button> -->
            <el-button type="text" size="mini" @click="commentRemove(scope.row.comment_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tc mt20" v-if="resultData.count>0">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { _commentList, _commentRemove } from "@/api/user.js";

export default {
  created() {
    this.initCommentsList();
    // console.log(this.$route.params);
  },
  data() {
    return {
      search: {
        page: 1,
        size: 10,
        keywords: "",
        course_id: "" ,//课程id
        state:"0",//状态
        // comment_mode:'',//类型,1:讲解;2:讨论;3问答
      },
      options: [
        {
          label: "全部",
          value: "0"
        },
        {
          label: "隐藏",
          value: "-1"
        },
        {
          label: "黑名单",
          value: "-2"
        },
        {
          label: "正常",
          value: "1"
        },
        {
          label: "精选",
          value: "2"
        }
      ],
      // name type num money date
      resultData: {
        data: []
      }
    };
  },
  components: {},
  methods: {
    //查询信息
    seachList() {
      this.initCommentsList();
    },
    //获取状态
    getStatus(val){
      this.initCommentsList();
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val;
      this.initCommentsList();
    },
    //加载列表
    initCommentsList() {
      _commentList({
        params: {
          page: this.search.page,
          size: this.search.size,
          keywords: this.search.keywords,
          state: this.search.state,
          course_id:this.$route.params.id
        }
      }).then(res => {
        this.loading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    //删除评论内容
    commentRemove(id) {
      this.$confirm("此操作将删除该谈论内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          _commentRemove({
            params: {
              id: id
            }
          }).then(res => {
            if (res.resultCode == 1) {
              this.$message.success(res.errorMsg);
              this.initCommentsList();
            } else {
              this.$message.error(res.errorMsg);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.live {
  .seach-list {
    .input-v {
      // width: 160px;
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
.list-wrap {
  .user_header {
    height: 50px;
    width: 50px;
    display: block;
    background: #efefef;
    border-radius: 50%;
  }
}
</style>